module.exports = __webpack_public_path__ + "img/volleyball.56ed639d.svg";